import { Routes } from '@angular/router';
import { LnHomeComponent } from '@pages/ln-home/ln-home.component';
import { LnProductInfoComponent } from '@pages/ln-product-info/ln-product-info.component';
import { LnPurchaseCompletionFormPageComponent } from '@pages/ln-purchase-completion-form-page/ln-purchase-completion-form-page.component';
import { SearchResultComponent } from '@pages/search-result/search-result.component';
import { ShoppingCarComponent } from '@pages/shopping-car/shopping-car.component';
import { AllArtisansDesignersCreatedProductsComponent } from '@pages/all-artisans-designers-created-products/all-artisans-designers-created-products.component';
import { ArtisanProfileComponent } from '@pages/artisan-profile/artisan-profile.component';
import { ContactComponent } from '@pages/contact/contact.component';
import { AllSpecialProductsComponent } from '@pages/all-special-products/all-special-products.component';
import { NoFoundComponent } from '@pages/no-found/no-found.component';
import { AboutUsComponent } from '@pages/about-us/about-us.component';
import { PurchaseCompletionGuardService } from '@core/guards/purchase-completion-guard/purchase-completion-guard.service';
import { ServiceDetailsComponent } from '@pages/service-details/service-details.component';
import { ServicesComponent } from '@pages/services/services.component';
import { BlogComponent } from '@pages/blog/blog.component';
import { BlogDetailsComponent } from '@pages/blog-details/blog-details.component';

export const routes: Routes = [
  { path: '', loadComponent: () => LnHomeComponent, pathMatch: 'full' },
  { path: 'product-details', loadComponent: () => LnProductInfoComponent },
  { path: 'search', loadComponent: () => SearchResultComponent },
  { path: 'shopping', loadComponent: () => ShoppingCarComponent },
  { path: 'all-artisans-products', loadComponent: () => AllArtisansDesignersCreatedProductsComponent },
  { path: 'all-special-products', loadComponent: () => AllSpecialProductsComponent },
  { path: 'artisan-profile', loadComponent: () => ArtisanProfileComponent },
  {
    path: 'purchase-completion-form',
    loadComponent: () => LnPurchaseCompletionFormPageComponent,
    canMatch: [PurchaseCompletionGuardService],
  },
  { path: 'contact', loadComponent: () => ContactComponent },
  { path: 'about-us', loadComponent: () => AboutUsComponent },
  { path: 'services', loadComponent: () => ServicesComponent },
  { path: 'blog', loadComponent: () => BlogComponent },
  { path: 'blog-details', loadComponent: () => BlogDetailsComponent },
  { path: 'service-details', loadComponent: () => ServiceDetailsComponent },
  { path: '404', loadComponent: () => NoFoundComponent },
  { path: '**', redirectTo: '404' },
];
